import { useState, useEffect } from 'react';

export function useGameRules() {
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [hasSeenRules, setHasSeenRules] = useState(true); // Default true to prevent hydration flash

  useEffect(() => {
    // Check local storage on mount
    const seen = localStorage.getItem('fjalafundit_rules_seen') === 'true';
    setHasSeenRules(seen);
  }, []);

  const closeRules = () => {
    setIsRulesOpen(false);
    if (!hasSeenRules) {
      localStorage.setItem('fjalafundit_rules_seen', 'true');
      setHasSeenRules(true);
    }
  };

  const openRules = () => setIsRulesOpen(true);

  return { isRulesOpen, hasSeenRules, openRules, closeRules };
}
